import { Analytics } from 'analytics';
import { type AnalyticsEventModel } from 'shisell';

import { consolePlugin, eipPlugin, googleAnalyticsPlugin, fullstoryPlugin } from './plugins';
import { v4 } from 'uuid';
import { parseSearchParams } from '@automation-suite/shared-utils-helpers';

const productionPlugins = [googleAnalyticsPlugin, eipPlugin, fullstoryPlugin];

const analytics = Analytics({
  app: 'widget-loader',
  plugins: process.env.NX_PUBLIC_APP_ENV === 'production' ? productionPlugins : [...productionPlugins, consolePlugin],
});

export const writer = (eventModel: AnalyticsEventModel) => {
  const isBrowser = typeof window !== 'undefined';
  const userAgent = isBrowser ? navigator.userAgent : '';
  const browser = userAgent.match(/(firefox|msie|chrome|safari|edge|opera|trident)/i)?.[0] || 'Unknown Browser';
  const os = userAgent.match(/(windows|mac|linux|android|iphone|ipad|ios)/i)?.[0] || 'Unknown OS';
  const device = /mobile/i.test(userAgent) ? 'Mobile' : /tablet/i.test(userAgent) ? 'Tablet' : 'Desktop';

  analytics.track(eventModel.Name, {
    ...eventModel,
    ExtraData: {
      ...eventModel.ExtraData,
      Browser: browser,
      Device: device,
      OS: os,
      ViewportWidth: isBrowser ? window.innerWidth : 0,
      ViewportHeight: isBrowser ? window.innerHeight : 0,
      DevicePixelRatio: isBrowser ? (window.devicePixelRatio ?? 1) : 1,
      FullStorySessionUrl: isBrowser ? window.FS?.getCurrentSessionURL?.() : undefined,
      HostUrl: isBrowser ? window.location.href : '',
      HostOrigin: isBrowser ? window.location.origin : '',
      HostPath: isBrowser ? window.location.pathname : '',
      HostQueryParams: isBrowser ? parseSearchParams(window.location.search) : {},
    },
    MetaData: {
      ...eventModel.MetaData,
      correlationId: v4(),
    },
  });
};
